import classNames from 'classnames';
import {
  type CSSProperties,
  forwardRef,
  type HTMLAttributes,
  type MouseEventHandler,
  type ReactNode,
} from 'react';

import styles from './FilterTag.module.css';

export interface FilterTagProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode;
  color?: string;
  onRemove?: MouseEventHandler<HTMLButtonElement>;
  removeLabel?: string;
  removeTestId?: string;
  removeDisabled?: boolean;
}

export const FilterTag = forwardRef<HTMLSpanElement, FilterTagProps>(
  function FilterTag(
    {
      children,
      color,
      onRemove,
      removeLabel = 'Remove',
      removeTestId,
      removeDisabled = false,
      className,
      ...rest
    },
    ref
  ) {
    return (
      <span ref={ref} className={classNames(styles.tag, className)} {...rest}>
        <span className={styles.label}>
          {color && (
            <span
              className={styles.swatch}
              style={{ '--filter-tag-swatch-color': color } as CSSProperties}
            />
          )}
          {children}
        </span>
        {onRemove && (
          <button
            type="button"
            aria-label={removeLabel}
            className={styles.close}
            disabled={removeDisabled}
            onPointerDown={(event) => event.stopPropagation()}
            onClick={(event) => {
              event.stopPropagation();
              onRemove?.(event);
            }}
            data-testid={removeTestId}
          >
            <svg viewBox="0 0 512 512" aria-hidden="true" focusable="false">
              <path
                fill="currentColor"
                d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"
              />
            </svg>
          </button>
        )}
      </span>
    );
  }
);
